import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

type TProps = {
  options: { title: string; url: string; selected: boolean }[];
};

export const BreadCrumbSelect: React.FC<TProps> = ({ options }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const onChange = ({ target }: any) => {
    const url: string = options.find((o) => o.title === target.value)
      ?.url as string;
    history.push(url);
  };

  return (
    <li className="breadcrumb-item active d-flex align-items-center justify-content-center">
      <select
        className="form-select form-select-sm"
        onChange={onChange}
        value={options.find((o) => o.selected)?.title}
      >
        {options.map((option) => {
          return (
            <option key={option.title} value={option.title} id={option.title}>
              {t(option.title)}
            </option>
          );
        })}
      </select>
    </li>
  );
};
